import React from "react";
import { useField } from "formik";
import { TextField } from "@material-ui/core";

const InputField = (props) => {
  const {
    maxLength = 3072,
    readOnly = false,
    extraLabel,
    label,
    placeholder,
    requiredField,
    rows,
    change,
    containerStyle,
    isSizeInput,
    isCuitInput,
    ...rest
  } = props;
  const [field, meta] = useField(props);
  const { touched, error } = meta;
  const isError = !!(touched && error);
  const labelField = requiredField ? `${label}*` : label;

  const renderHelperText = () => {
    if (isError) {
      return error;
    } else if (extraLabel) {
      return extraLabel;
    }
  };

  const formatCuit = (value) => {
    const cleaned = value.replace(/\D/g, '');

    const limited = cleaned.slice(0, 11);

    if (limited.length <= 2) {
      return limited;
    } else if (limited.length <= 10) {
      return `${limited.slice(0, 2)}-${limited.slice(2)}`;
    } else {
      return `${limited.slice(0, 2)}-${limited.slice(2, 10)}-${limited.slice(10)}`;
    }
  };

  return (
    <TextField
      {...field}
      style={containerStyle}
      label={labelField}
      multiline={!!rows}
      minRows={rows}
      error={isError}
      placeholder={placeholder}
      helperText={renderHelperText()}
      inputProps={{ maxLength: maxLength, readOnly: readOnly }}
      onChange={(e) => {
        if (isCuitInput) {
          const formattedValue = formatCuit(e.target.value);
          field.onChange({ target: { name: field.name, value: formattedValue } });
          return;
        }

        const hasComma = e.target.value.includes(',');
        const hasDot = e.target.value.includes('.');
        const formatted = e.target.value.length >= 2 && !hasComma && !hasDot ? e.target.value.slice(0, 1) + ',' + e.target.value.slice(1): e.target.value;
        if(isSizeInput){
          const commaCount = formatted.split(',').length - 1;
          if (formatted.length > 4) {
            e.target.value = formatted.slice(0, 4);
          } else if (commaCount > 1) {
            // Remove additional commas
            e.target.value = formatted.replace(/,/g, (_, index) => (index === 1 ? ',' : ''));
          } else {
            e.target.value = formatted
          }
        }

        field.onChange(e);
        if (change) {
          change(e);
        }
      }}
      {...rest}
    />
  );
};

export default InputField;
